(function(){
    angular
        .module('app')
        .directive('ngCrearpaciente', crearpaciente);

        crearpaciente.$inject = ['$timeout'];
        function crearpaciente($timeout){
            return {
	            templateUrl: '/uranolab/crearpaciente?lang_id='+lang_id,
		          scope: {
		          	cancelar:"&",
					aceptar:'&',
					cancelarbutton:'=',
					pa:'='
		          	//muestra:"="
	              },
            	link: function (scope, element, $attrs, ngModel) {
		            return $timeout(function () {
                    	scope.cancelarBtn = function(){
                    		scope.cancelar();
                    	}
                    	scope.aceptarBtn = function(){
                    		scope.aceptar();
                    	}
		            });
		        }
          }
      	}
})();